// extracted by mini-css-extract-plugin
export default {"title":"styles_title__uAlHW","actionButton":"styles_actionButton__BMmyC"};